import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getReleaseDetails=(selectedProduct:string)=>apiClient.get(`${endpoints.pathPrefix}release-details?product=${selectedProduct}`);

const releaseDetialsApiList = {
    getReleaseDetails    
};
export default releaseDetialsApiList;
